// extracted by mini-css-extract-plugin
export default {"container":"list-header_container__k2W7-","title":"list-header_title__1H4HA"};